import { render, staticRenderFns } from "./WishListCount.vue?vue&type=template&id=156f65ab"
import script from "./WishListCount.vue?vue&type=script&lang=js"
export * from "./WishListCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyDev2025/7843/112/Servershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156f65ab')) {
      api.createRecord('156f65ab', component.options)
    } else {
      api.reload('156f65ab', component.options)
    }
    module.hot.accept("./WishListCount.vue?vue&type=template&id=156f65ab", function () {
      api.rerender('156f65ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/servershop/WishListCount.vue"
export default component.exports